import styled from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
  input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    width: 24px;
    height: 24px;
    border-radius: 0.15em;
    margin-right: 0.5em;
    border: 0.15em solid ${theme.primaryColor};
    outline: none;
    cursor: pointer;
  }

  input:checked {
    background-color: ${theme.primaryColor};
    position: relative;
  }

  input:checked::before {
    content: "✓";
    font-size: 18px;
    color: #fff;
    position: absolute;
    right: 2.5px;
    top: -2.5px;
  }

  input[type="checkbox"]:disabled {
    border-color: #c0c0c0;
    background-color: #c0c0c0;
  }

  input[type="checkbox"]:disabled + span {
    color: #c0c0c0;
  }
`;

export { Container };